import React from 'react';
import Header from '../HeaderSection/Header';
import Breadcrumb from './Breadcrumb';
import Blog from './Blog';
import FooterSection from '../FooterSection/FooterTwo';

const BlogTwoColumn = () => {
    return (
        <div className="blog">
            {/*====== Scroll To Top Area Start ======*/}
            <div id="scrollUp" title="Scroll To Top">
                <i className="fas fa-arrow-up" />
            </div>
            {/*====== Scroll To Top Area End ======*/}
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                <Breadcrumb title="Blog - 2 Column" />
                <section id="blog" className="section blog-area ptb_100">
                    <div className="container">
                        <Blog />
                    </div>
                </section>
                <FooterSection />
            </div>
        </div>
    );
}

export default BlogTwoColumn;